import React from "react";
import { StyledCell } from "./index";

const WallCell = () => {
  return (
    <StyledCell>
      <img src="/wall5.png" alt="tree" />
    </StyledCell>
  );
};

export default WallCell;
